module.exports = __webpack_public_path__ + "img/elo.a89593b.png";